<template>
  <div>
    <div v-if="authUser">
      <breadcrumb-header :items="breadcrumbs" />
    </div>
    <div v-else>
      <global-header :title="t('policies.privacy')" />
    </div>
    <v-container>
      <rich-text-content
        :data="getSetting('privacy_policy')"
      />
    </v-container>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import RichTextContent from '@/components/rich-text/RichTextContent.vue';
import { useAuth, useSettings } from '@/composables';
import GlobalHeader from './GlobalHeader.vue';

const { t } = useI18n();
const { getSetting } = useSettings();
const { authUser } = useAuth();

const breadcrumbs = computed(() => [
  {
    title: t('policies.privacy'),
  },
]);
</script>
